<tg-row class="summary-agent-contact-detail__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">
            {{
                contactDetailType === propertyAgentContactDetailsType.primary
                    ? 'Contact '
                    : 'Second contact '
            }}
            details
        </p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-agent-contact-detail__header--right">
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited">
            Edit
            {{
                contactDetailType === propertyAgentContactDetailsType.primary
                    ? ' '
                    : ' second '
            }}
            contact details
        </a>
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-agent-contact-detail__content">
        <span class="summary-agent-contact-detail__content-label">
            Full name:
        </span>
        {{ contactDetailData.name }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-agent-contact-detail__content">
        <span class="summary-agent-contact-detail__content-label">
            Mobile phone:
        </span>
        {{ contactDetailData.mobile }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-agent-contact-detail__content">
        <span class="summary-agent-contact-detail__content-label">
            Landline phone:
        </span>
        {{ contactDetailData.landLine }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-agent-contact-detail__content">
        <span class="summary-agent-contact-detail__content-label">
            Email:
        </span>
        {{ contactDetailData.email }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-agent-contact-detail__content">
        <tg-info-box *ngIf="contactDetailData.isPhotoRemovalDisabled">
            To update the profile photo for this contact on the listing, update the agent’s
             <a target=“_blank” href="https://onehub.co.nz">OneHub</a> profile.
        </tg-info-box>
        <tg-info-box *ngIf="!contactDetailData.isPhotoRemovalDisabled">
            If this contact is a licensed agent and has an active
             <a target="_blank" href="https://onehub.co.nz">OneHub</a> profile,
             their OneHub profile photo will be displayed on the listing.
        </tg-info-box>
    </tg-col>
</tg-row>
<tg-row *ngIf="contactDetailData.photoUrl">
    <tg-col
        aria-label="agent photo"
        class="summary-agent-contact-detail__content"
        role="listitem"
        sm="6"
        lg="3">
        <tm-list-photo-card
            [activatable]="false"
            [photo]="photo"
            [isThumbnail]="true"
            attr.aria-label="1"
            tabindex="0">
            <tg-icon
                class="summary-page-photos-contact-detail-section__photo--main"
                name="star-fill"
                role="presentation">
            </tg-icon>
        </tm-list-photo-card>
    </tg-col>
</tg-row>
